if (!customElements.get("testimonials-section")) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
      this.initialise();
    }

    initialise() {
      this.svgs = this.querySelectorAll(".logo-wrapper svg");
      this.wrappers = this.querySelectorAll(".logo-wrapper");

      for (let i = 0; i < this.svgs.length; i++) {
        const svg = this.svgs[i];
        const heightFactor = svg.height.baseVal.value / svg.width.baseVal.value;
        const width = this.wrappers[i].offsetWidth * 0.8;

        svg.style.width = width + "px";
        svg.style.height = width * heightFactor + "px";
      }

      if (screen.width < 1201) {
        this.scrollLeft = (this.scrollWidth - this.offsetWidth) / 2;
      }
    }
  }

  customElements.define("testimonials-section", Testimonials);
}
